import React, {useEffect} from "react";
import TopbarSearch         from "./TopbarSearch";
import TopbarNotifications  from "./TopbarNotifications";
import TopbarMessages       from "./TopbarMessages";
import TopbarLanguages      from "./TopbarLanguages";
import TopbarUser           from "./TopbarUser";
import layoutActions        from "@pillvery/redux/layout/actions";
import {useDispatch, useSelector} from "react-redux";

export default function RightTopbarItems() {
    const dispatch              = useDispatch();
    const { isSidebarOpen } = useSelector(state => state.Layout )

    useEffect(() =>{
        const sidebar = document.getElementById("sidebar");

        if(sidebar ){
            if(!isSidebarOpen){
                sidebar.classList.add("active")
            }else{
                sidebar.classList.remove("active")
            }
        }
    }, [isSidebarOpen])


    function handleToggle() {
        dispatch(layoutActions.toggleRightbar())
    }

    function handleToggleSidebar() {
        dispatch(layoutActions.toggleSidebar())
        console.log("jj")
    }

    return (
        <>
            <ul className="navbar-nav navbar-nav-right">
                {/*<TopbarSearch />*/}

                <TopbarNotifications />

                {/*<TopbarMessages />*/}

                {/*<TopbarLanguages />*/}

                <TopbarUser />

                {/*<li className="nav-item nav-settings d-none d-lg-flex">*/}
                {/*    <a className="nav-link" onClick={ handleToggle }>*/}
                {/*        <i className="mdi mdi-dots-horizontal"></i>*/}
                {/*    </a>*/}
                {/*</li>*/}
            </ul>
            <button className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
                    type="button"
                    data-toggle="offcanvas"
                    onClick={ handleToggleSidebar }
            >
                <span className="mdi mdi-menu"></span>
            </button>
        </>
    )
}